import { render } from "./Paginacao.vue?vue&type=template&id=7370fe0e&scoped=true&ts=true"
import script from "./Paginacao.vue?vue&type=script&lang=ts"
export * from "./Paginacao.vue?vue&type=script&lang=ts"

import "./Paginacao.vue?vue&type=style&index=0&id=7370fe0e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7370fe0e"]])

export default __exports__